const Footer = () => {
    return (
        <div className="fixed bottom-0 px-3 py-1.5 bg-slate-700 w-full text-white text-xs border-t border-t-slate-600">
            <p>Powered by <b>ROBOSYS </b>Solutions</p>
        </div>
    )
}

export default Footer;